import { Types } from "../actionTypes";
import { combineReducers } from "@reduxjs/toolkit";

const deals = (state = {}, action) => {
  switch (action.type) {
    case Types.FETCH_DEALS_SUCCESS: {
      return {
        ...state,
        deals: action.response,
      };
    }
    case Types.FETCH_DEALS_FAILURE: {
      return {
        ...state,
        error: action.response,
      };
    }
    default:
      return state;
  }
};

export const getDeals = (state) => state.deals;
export const getErrorMsg = (state) => state.error;

export default combineReducers({
  deals,
});
